import React, { useContext, useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import GlobalContext from '../../GlobalContext'
import GoodCheck from '../../components/GoodCheck'
import '../../css/userFilterModal.css'
import { RiCheckLine } from 'react-icons/ri'

const UserFilterModal = ({ show, setShow }) => {

    const globalContext = useContext(GlobalContext)

    const [users, setUsers] = useState([])
    const [selected, setSelected] = useState([])
    const [filter, setFilter] = useState('')

    const closeUserFilter = () => {
        setShow(false)
        setFilter('')
        loadUsers()
    }
    const submit=()=>{
        let lusers=[]
        if(selected.length<=0){
           lusers=[globalContext.get.User.ID]
        } else {
            lusers=selected
        }
        globalContext.set(draft=>{draft.showUsersList=lusers})
        closeUserFilter()
    }
    const toggleSelected=(ID)=>{
        if(selected.includes(ID)){
            setSelected(selected.filter((value)=> value !== ID))
        } else {
            setSelected([...selected, ID])
        }
    }
    const allSelected=()=>{
        const filteredUsers=filterList(users)
        if(filteredUsers.length!==selected.length){
            return false
        }
        return filteredUsers.every(use=>{
            return selected.includes(use.ID)
        })
    }
    const toggleAll=()=>{
        if(allSelected()){
            setSelected([])
        } else {
            setSelected(filterList(users).map((user)=>user.ID))
        }
    }
    const filterList = (list) => {
        if (filter == '') {
            return list
        }
        let newList = []
        list.forEach(use => {
            if (use.use_username.toLowerCase().includes(filter.toLocaleLowerCase())) {
                newList.push(use)
            }
        })
        return newList

    }
    const loadUsers=()=>{
        if (globalContext.get) {
            if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
                let l_users = []
                let ids = []
                globalContext.get.shops.forEach(sho => {
                    sho.Users.forEach(use => {
                        if (!ids.includes(use.ID)) {
                            ids.push(use.ID)
                            l_users.push(use)
                        }
                    })
                })
                setUsers(l_users)
            }
            if (globalContext.get.showUsersList) {
                if (![1, 2].includes(globalContext.get.showUsersList)) {
                    setSelected(JSON.parse(JSON.stringify(globalContext.get.showUsersList)))
                }
            }
        }
    }

    useEffect(() => {
        loadUsers()
    }, [globalContext.get])

   

    return (
        <Modal show={show} onHide={closeUserFilter}>
            <ModalHeader closeButton>
                <ModalTitle className='nac-title'>Seleziona utenti</ModalTitle>
            </ModalHeader>
            <ModalBody className='ufm-modal-body'>
                <div className='ufm-search-container'>
                    <input
                        className='ufm-search-bar'
                        type='text'
                        placeholder="Cerca utente"
                        value={filter}
                        onChange={(e)=>setFilter(e.target.value)}
                    />
                    <GoodCheck
                        defaultChecked={allSelected()}
                        onChange={toggleAll}
                        custom_styles={{
                            container: {
                                width: '10%'
                            },
                            label: {
                                width: '0%'
                            },
                            check: {
                                width: '100%'
                            },
                            help: {
                                width: '0%'
                            }
                        }}
                    />
                </div>
                <hr className='hr-cool' />
                <div className='ufm-user-list-container'>
                    {filterList(users).map(use=>(
                        <UserItem
                            key={use.ID}
                            username={use.use_username}
                            color={use.use_color}
                            isSelected={selected.includes(use.ID)}
                            onChange={()=>{toggleSelected(use.ID)}}
                        />
                    ))}
                </div>
            </ModalBody>
            <ModalFooter>
             <div className='ufm-footer'>
                <button type='button' className='nac-button' onClick={submit}>
                    <RiCheckLine size={'24pt'} />
                </button>
             </div>
            </ModalFooter>
        </Modal>
    )
}

export default UserFilterModal


const UserItem = ({ username, color="#fbae16", isSelected, onChange }) => {

    return (
        <div 
            className='ufm-user-item mb-4'
            style={{borderLeftColor: color}}
        >
            <p className='ufm-user-name'>{username}</p>
            <GoodCheck
                custom_styles={{
                    container: {
                        width: '10%'
                    },
                    label: {
                        width: '0%'
                    },
                    check: {
                        width: '100%'
                    },
                    help: {
                        width: '0%'
                    }
                }}
                defaultChecked={isSelected}
                onChange={onChange}
            />
        </div>
    )
}